import type { ComponentInit } from "@scripts/registry";
import { createTrack } from "@scripts/track";

const TRACK = "[data-fa-shop-callout-track]";
const ITEM = "[data-fa-shop-callout-item]";
const PREV = '[data-fa-shop-callout-arrow="prev"]';
const NEXT = '[data-fa-shop-callout-arrow="next"]';

export const initShopCallout: ComponentInit = (root) => {
	const track = root.querySelector<HTMLElement>(TRACK);
	const prev = root.querySelector<HTMLElement>(PREV);
	const next = root.querySelector<HTMLElement>(NEXT);

	if (!track || !prev || !next) return;

	return createTrack({ track, prev, next, item: ITEM });
};
